"use client";
import React, {useState} from 'react';
import styles from './StatucSection.module.css';
import icStatusLine from "../assets/icon/ic_status_line.svg";
import icWallet from "../assets/icon/ic_wallet.svg";
import {useTranslation} from "react-i18next";

export interface WhiteListInfo {
    code: number;
    message: string;
    result: Result[];
}

export interface Result {
    chain: string;
    dc: boolean;
    stake: boolean;
    delegate: boolean;
    is_ok: boolean;
}

const StatusSection: React.FC = () => {
    const [walletAddress, setWalletAddress] = useState('');
    const [status, setStatus] = useState('');
    const [err, setErr] = useState('');
    const {t} = useTranslation();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            if (walletAddress.length < 38) {
                setErr(t('statusValid'));
                return;
            } else {
                setErr('');
            }

            setStatus('Loading ...');

            const response = await fetch('https://pell.satoshiapp.xyz/dapi/white-list/pellStatus.htm', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: new URLSearchParams({
                    'address': walletAddress,
                })
            });

            const formData = new FormData();
            formData.append('address', walletAddress);

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const responseDetail = await fetch(`https://api-test.pell.network/v1/testnet/getTestnetTaskProgress?address=${walletAddress}`);
            if (!responseDetail.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            const dataDetail: WhiteListInfo = await responseDetail.json();

            console.log('data ', data);
            console.log('dataDetail ', dataDetail);
            const core: Result | undefined = dataDetail.result.find(x => x.chain == 'core');
            const mantle: Result | undefined = dataDetail.result.find(x => x.chain == 'mantle');
            const bsc: Result | undefined = dataDetail.result.find(x => x.chain == 'bsc');

            if (data["data"]["status"] === 0) {

                if (core && mantle && bsc) {
                    if (!core.dc && !core.stake)
                        if (!mantle.dc && !mantle.stake)
                            if (!bsc.dc && !bsc.stake) {
                                setStatus(t('status0'));
                                return;
                            }
                }

                if (core && mantle && bsc) {
                    if ((!core.dc && core.stake) || (!mantle.dc && mantle.stake) || (!bsc.dc && bsc.stake)) {
                        setStatus(t('status_discord'));
                        return;
                    }
                }

                if (core && mantle && bsc) {
                    let message = t('status0_below');
                    message += `\n- Core Chain: ${core.stake ? t('no_tokens_delegated') : t('no_quest_started')}`
                    message += `\n- BNB Chain: ${bsc.stake ? t('no_tokens_delegated') : t('no_quest_started')}`
                    message += `\n- Mantle Chain: ${mantle.stake ? t('no_tokens_delegated') : t('no_quest_started')}`
                    setStatus(message);
                    return;
                }

            } else if (data["data"]["status"] === 1) {
                if (core && mantle && bsc) {
                    let message = t('status1_below');
                    message += `\n- Core Chain: ${core.is_ok ? t('completed') : core.stake ? t('no_tokens_delegated'): t('no_quest_started')}`
                    message += `\n- BNB Chain: ${bsc.is_ok ? t('completed') : bsc.stake ? t('no_tokens_delegated'): t('no_quest_started')}`
                    message += `\n- Mantle Chain: ${mantle.is_ok ? 'Completed' : mantle.stake ? t('no_tokens_delegated'): t('no_quest_started')}`
                    setStatus(message);
                    return;
                }
            } else if (data["data"]["status"] === 2) {
                if (core && mantle && bsc) {
                    let message = t('status2_below');
                    message += `\n- Core Chain: ${core.is_ok ? t('completed') : core.stake ? t('no_tokens_delegated'): t('no_quest_started')}`
                    message += `\n- BNB Chain: ${bsc.is_ok ? t('completed') : bsc.stake ? t('no_tokens_delegated'): t('no_quest_started')}`
                    message += `\n- Mantle Chain: ${mantle.is_ok ? t('completed') : mantle.stake ? t('no_tokens_delegated'): t('no_quest_started')}`
                    setStatus(message);
                    return;
                }
            } else if (data["data"]["status"] === 3) {
                setStatus(t('status3'));
            }
        } catch (error) {
            setStatus((error as Error).message ?? '');
        }
    };

    return (
        <section className={styles.statusSection}>
            <div className={styles.content}>
                <div className={styles.imageContainer}>
                    <div className={styles.imageWrapper}>
                        <img
                            src={icStatusLine}
                            className={styles.airdropImage}/>
                    </div>
                </div>
                <h2 className={styles.statusCheckTitle}>
                    {t('statusComplete')}
                </h2>
                <form onSubmit={handleSubmit} className={styles.formContainer}>
                    <div className={styles.inputField}>
                        <label htmlFor="walletAddress"
                               className={styles.visuallyHidden}>{t('statusEnterWallet')}</label>
                        <div className={styles.inputWrapper}>
                            <img src={icWallet} alt="" className={styles.inputIcon}/>
                            <input
                                type="text"
                                autoComplete="off"
                                id="walletAddress"
                                value={walletAddress}
                                onChange={(e) => setWalletAddress(e.target.value)}
                                placeholder={t('statusEnterWallet')}
                                className={styles.inputPlaceholder}
                            />
                        </div>
                    </div>
                    <div className={styles.buttonContainer}>
                        <button type="submit" className={styles.subscribeButton}>
                            <span className={styles.buttonText}>{t('statusCheck')}</span>
                        </button>
                        {status && (
                            <p className={styles.statusText}>{status}</p>
                        )}
                        {err && (
                            <p className={styles.errText}>{err}</p>
                        )}
                    </div>
                </form>
            </div>
        </section>
    );
};

export default StatusSection;